// Import controller
import addAnnouncementCTRL from 'controllers/announcement/addAnnouncement'
// Actions
export const START_ADD_ANNOUNCEMENT = 'START_ADD_ANNOUNCEMENT'
export const SUCCESS_ADD_ANNOUNCEMENT = 'SUCCESS_ADD_ANNOUNCEMENT'
export const FAILED_ADD_ANNOUNCEMENT = 'FAILED_ADD_ANNOUNCEMENT'


// Action Creator
export function addAnnouncement(schoolId, announcementInfo, callback){
  return function(dispatch) {

    dispatch({
      type: START_ADD_ANNOUNCEMENT,
      payload: {adding: true, announcementInfo}
    })

    addAnnouncementCTRL(schoolId, announcementInfo)
    .then((result) => {
      dispatch({
        type: SUCCESS_ADD_ANNOUNCEMENT,
        payload: {...result, adding: false}
      })
      callback()
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_ADD_ANNOUNCEMENT,
        payload: err
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/redux/actions/addAnnouncement.js